// Prices page component
export function FaqCustomerInfoPage() {
    return `
<div class="min-h-screen bg-gray-50">
    <div class="hero">
        <div class="hero-content">
            <h1 class="hero-title">Information</h1>
            <p class="hero-subtitle">For customers</p>
        </div>
    </div>

    <section class="section bg-gray-50">

        <div class="container">
           <div class="md:flex md:items-start md:space-x-8">

            <main class="md:w-2/3">

                <div class="max-w-4xl mx-auto prose prose-lg">

                    <div class="bg-white p-8 rounded-lg shadow-sm">
                        <h2 id="can-i-object" class="text-2xl text-blue-900 mb-4">Can I file an objection against the energy certificate?</h2>
<p class="mb-4">
Do you disagree with the energy certificate assigned to your home or commercial property? For example, because you believe the energy certification technician did not properly assess the property or that certain characteristics were not included in the calculation.

First, contact the advisor who prepared the energy certificate directly. Explain why you disagree with their assessment. In many cases, the advisor can review the calculation or, if necessary, schedule a new visit.

Unable to resolve the issue? Then you can contact the competent regional authority where the certificate was registered. Each Spanish region has its own authority responsible for supervising and registering energy certificates. This body can investigate whether the registration was carried out correctly in accordance with national regulations (Royal Decree 390/2021).

Are you a tenant and believe the energy certificate is incorrect? Contact the property owner first. The owner can follow the same steps: consult the certification technician or, if necessary, file a complaint with the competent regional authority.

A correct energy certificate is important, as it can influence the rental price and the valuation of the property.
</p>
</div>
</div>

<br></br>

<div class="max-w-4xl mx-auto prose prose-lg">
    <div class="bg-white p-8 rounded-lg shadow-sm">
        <h2 id="where-can-i-find" class="text-2xl text-blue-900 mb-4">Where can I consult the energy certificate of my home or commercial property?</h2>
        <p class="mb-4">
Would you like to consult the energy certificate of your home or business? In Spain, energy certificates are not registered at national level, but regionally. Each autonomous community has its own official database where all certificates are stored and verified. After the energy certification technician prepares the certificate, it is registered with the competent regional authority.

After registration, you will receive the official energy certificate by email in PDF format, together with the registration number assigned by the regional administration. This number proves that the certificate is valid and officially registered.

An energy certificate registered in Spain is valid for 10 years from the date of registration. During this period, anyone — such as potential buyers or tenants — can consult the certificate through the public registry of the corresponding region. This provides a clear view of the property’s energy performance and enables a fair comparison between homes and buildings.

It is also mandatory to indicate the energy rating (from A to G) in sales or rental advertisements, both online and offline.

Does your certificate not appear in the regional registry? Then it may have expired or not been registered correctly. Through EPCspainhomes.com you can easily select a new advisor and obtain a valid and officially registered energy certificate within a few days.
</p>
    </div>
</div>

<br></br>

<div class="max-w-4xl mx-auto prose prose-lg">
    <div class="bg-white p-8 rounded-lg shadow-sm">
        <h2 id="how-is-performance-determined" class="text-2xl text-blue-900 mb-4">How is the energy efficiency of my home or commercial property determined?</h2>
        <p class="mb-4">
How is the energy efficiency of my home determined?

After selecting an energy certification technician through EPCspainhomes.com, the advisor will contact you to schedule an appointment. During the visit — which usually lasts between one hour and one and a half hours — the advisor will assess the energy efficiency of your home in accordance with Spanish regulations (Royal Decree 390/2021).

The assessment is based on more than 150 characteristics of the property, such as:
• general characteristics (dimensions, year of construction, and type of property);  
• the surface area of the floor, roof, and façade;  
• the insulation of the roof, walls, floors, and windows;  
• heating, hot water, ventilation, air-conditioning, and solar energy installations.

The energy certificate is calculated based on the theoretical energy consumption in kWh per m² per year and the percentage of renewable energy used. The lower the energy consumption and the higher the use of renewable energy, the better the energy rating of the property.



How is the energy efficiency of my commercial property determined?

For commercial properties, the process is very similar. Once the certification technician has been selected through EPCspainhomes.com, the advisor will schedule an appointment with you. The duration of the visit depends on the size and complexity of the building.
</p>
    </div>
</div>

<br></br>

<div class="max-w-4xl mx-auto prose prose-lg">
    <div class="bg-white p-8 rounded-lg shadow-sm">
        <h2 id="how-fast" class="text-2xl text-blue-900 mb-4">How long will it take to receive an energy certificate?</h2>
        <p class="mb-4">
The time required to receive your energy certificate mainly depends on the location of the home or commercial property. In each region of Spain, different energy certification technicians operate, each with their own availability and delivery times.

In general, you can receive the energy certificate within a few days to two weeks after the inspection. The exact timeframe depends on:
• the autonomous community where the property is located;  
• the availability of the selected technician;  
• the size and complexity of the property.

A small apartment can usually be completed within a few days, while a large or multi-storey building may require more time for evaluation and report preparation.

Do you need the certificate urgently, for example to sell or rent out the property? On EPCspainhomes.com you can filter by delivery time. Some advisors offer an express service for a slightly higher price, allowing you to obtain a registered certificate within just a few days.
</p>
    </div>
</div>

<br></br>

<div class="max-w-4xl mx-auto prose prose-lg">
    <div class="bg-white p-8 rounded-lg shadow-sm">
        <h2 id="data-from-government" class="text-2xl text-blue-900 mb-4">How do we obtain data about your home or commercial property from the authorities?</h2>
        <p class="mb-4">
When you search for a certification technician through EPCspainhomes.com, we ask you for some basic property details, such as:
• the address of the home or commercial property;  
• the type of building (apartment, single-family home, or office space);  
• and, if known, the surface area of the building.

With this information, we show the advisors available in your region, along with their prices, ratings, and delivery times. This allows you to easily compare and select the advisor that best suits your needs.

In Spain, official property data is managed by the Cadastre, the State’s cadastral registry. This database contains information about location, usable surface area, year of construction, and property use. Certification technicians use this data as a reference during the inspection, but EPCspainhomes.com does not automatically retrieve this information. You always remain in control of the information you provide.

During the inspection, the technician will verify the main characteristics of the property — such as dimensions, use, and type of construction — to ensure that the energy certificate is prepared using correct and up-to-date information.
</p>
    </div>
</div>

<br></br>

<div class="max-w-4xl mx-auto prose prose-lg">
    <div class="bg-white p-8 rounded-lg shadow-sm">
        <h2 id="price" class="text-2xl text-blue-900 mb-4">What is the price of an energy certificate?</h2>
        <p class="mb-4">
The price of an energy certificate for a home or commercial property in Spain depends on several factors. The main ones are:

• The type of building – A certificate for an apartment is usually more affordable than one for a single-family home, office, or commercial premises.  
• The surface area – The larger the property, the more time the technician will need for inspection and calculation, and the higher the price.  
• The complexity of the building – Properties with multiple floors, extensions, or mixed uses require more measurement and analysis work.  
• The region – Each autonomous community has different certification technicians, each with their own pricing and availability.

The prices of an energy certificate in Spain typically range between <strong>€100 and €250 for homes</strong>, and between <strong>€200 and €600 for commercial properties</strong>, depending on size and location.
</p>

<p class="mb-4">
Would you like to know exactly how much the energy certificate costs for your home or commercial property?
Then use the EPCspainhomes.com comparison tool. You will immediately see:

the advisors available in your region,

their prices, delivery times, and ratings,

and which options are available for an express service.
</p>


So you can easily choose the advisor that best suits your situation and budget.
</p>

<h2 class="text-2xl text-blue-900 mb-4">Who is the most suitable energy certificate advisor for me?</h2>

<p class="mb-4">
Which energy certification technician is best for you depends on your situation and preferences.
Through EPCspainhomes.com you can easily find the advisor that best matches your needs.

Enter the address or postal code of your home or premises in our comparison tool.
Then indicate the type of property — for example, an apartment, single-family home, or office space. You can also enter the surface area (or adjust it if it is not exact).

Our comparison tool automatically shows the certified energy advisors available in your region, including:
• their prices,  
• the estimated delivery time,  
• and ratings from other customers.

You can then easily filter based on what you consider important:
for example, the lowest price, the fastest delivery, or the best-rated advisor.

Once you have found the right advisor, fill in some additional details in the request form so the technician can contact you and plan the visit. This form appears when you click the green “Request” button next to the selected advisor.

After submitting the request, the technician will receive your details and contact you to confirm the inspection.
All advisors on EPCspainhomes.com work with transparent pricing: what you see in the comparison tool is what you will pay. If anything does not match, please do not hesitate to contact our customer service at info@EPCspainhomes.com.
</p>

<h2 class="text-2xl text-blue-900 mb-4">What are our requirements for energy certificate advisors?</h2>

<p class="mb-4">
To operate on EPCspainhomes.com, all energy certification technicians must be officially accredited and authorized to issue energy certificates in accordance with Spanish legislation (Royal Decree 390/2021).

This regulation establishes that advisors must have appropriate technical training — such as architecture, engineering, or technical architecture — and be authorized to carry out and register energy efficiency certificates with the relevant regional authority.

In addition, all advisors working through EPCspainhomes.com must:
• have proven experience in energy certification;  
• use official Spanish methods (such as CE3X or HULC);  
• comply with the quality standards established in Royal Decree 390/2021;  
• and work with transparent pricing and customer-oriented communication.

Finally, we place great value on professionalism, reliability, and friendliness.
That is why we only select advisors who are not only technically competent, but also communicate clearly and approach clients with a courteous attitude.
</p>

<h2 class="text-2xl text-blue-900 mb-4">What does an energy certificate advisor do in your home?</h2>

<p class="mb-4">
The energy certification technician examines your home from top to bottom to determine its energy efficiency. This inspection is mandatory in Spain under Royal Decree 390/2021.

First, the advisor discusses the basic information about the property with you. Do you have floor plans, photos, or invoices from previous renovations? This helps to obtain a more accurate picture of the property’s energy characteristics.

Then the physical inspection is carried out. The technician checks:
• the insulation of walls, floors, roof, and windows;  
• the type of glazing (single, double, or triple);  
• the thickness of insulation layers;  
• heating, hot water, and air-conditioning systems;  
• possible renewable energy sources such as solar panels or heat pumps;  
• and the property’s ventilation systems.

The advisor may use measuring equipment to determine whether windows have insulating layers and how well the property retains heat. Less heat loss means lower energy consumption and therefore a better energy rating.

The complete inspection usually takes between 45 minutes and one and a half hours, depending on the size and complexity of the property.
After the visit, the advisor enters all data into the official software (CE3X or HULC), calculates the energy efficiency, and registers the certificate with the relevant regional authority.

You will then receive the official energy certificate in PDF format, including proof of registration.

Preparing an energy certificate is technical work that requires precision and specialized knowledge.
Through EPCspainhomes.com you can easily find the best certified technicians in your area — based on price, rating, and delivery time — to ensure that your certificate is correct and officially registered.
</p>

<h2 class="text-2xl text-blue-900 mb-4">Can I request an energy certificate as a representative or heir?</h2>

<p class="mb-4">
Are you a representative or heir of a home or commercial property?
Then you can easily request an energy certificate on behalf of the owner through EPCspainhomes.com.
On the homepage, enter the property details — such as address, type of building, and estimated surface area. Our comparison tool will then show the energy certification technicians available in the region where the property is located.

You can then filter by:
• price,  
• delivery time,  
• and advisor rating.

Have you chosen the advisor that best suits your needs? Click the green “Request” button. You will be redirected to the form where you enter your details and those of the property. The selected advisor will receive the request and contact you to plan the inspection.

Are you a real estate agent and want to request a certificate for a client?
This is also possible through EPCspainhomes.com. Enter the address and property details, compare the available advisors, and choose the one that best fits your schedule or preferences.
Once the request is submitted, the advisor will contact you directly or the owner to confirm the inspection.

In this way, as a representative, heir, or real estate agent, you can quickly ensure that the property has a valid and officially registered energy certificate — without complicated procedures.
</p>

<h2 class="text-2xl text-blue-900 mb-4">How can I cancel an energy certificate request?</h2>

<p class="mb-4">
At EPCspainhomes.com we strive to make the process of requesting an energy certificate as clear and simple as possible.
When you submit a request, both you and the selected advisor immediately receive complete information about the costs, with no later surprises.

All prices shown on our website are full prices, including VAT and any travel costs.
This way, you always know exactly what you will pay and can easily choose the advisor that best suits your needs.

We do not work with traditional quotations, but with clear service orders, so the technician can immediately begin preparing the inspection and calculating the certificate.

However, we understand that plans can change. That is why we offer the possibility to cancel your request as long as the inspection has not yet taken place.
Any cancellation conditions or costs will always be clearly indicated by the advisor before you confirm the request.

Our philosophy is based on clarity, trust, and flexibility — so that you have a pleasant experience and our advisors can work efficiently.
At EPCspainhomes.com we believe this is the ideal basis for a professional and transparent collaboration.
</p>

<p class="mb-4">Start comparing energy certificate advisors in Spain.</p>

<p><a href="/" class="btn bg-green-500 text-white px-6 py-3 rounded-lg font-medium inline-block">Compare advisors</a></p>

        `;
}